import { ILoadingEntityAction } from './ILoadingEntityAction';
import type { PayloadAction } from '@reduxjs/toolkit';

export abstract class ICrudEntityAction<E> extends ILoadingEntityAction {
  protected abstract fetchDataSuccess(item: E): PayloadAction<E>;

  protected abstract cacheDataSuccess(item: E): PayloadAction<E>;
}
